import styled, { css, keyframes } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const DropdownButton = styled.button`
  width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${Colors.GS1000};

  &:hover,
  &:focus {
    background: ${Colors.GS400};
  }
`

export const Card = styled.div`
  padding: 10px;
  cursor: pointer;
`

export const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
`

export const TagContainer = styled.div`
  display: flex;
  padding-top: 6px;
`

export const Container = styled.div<{ isActive: boolean }>`
  position: relative;
  background-color: ${Colors.GS200};
  border-radius: 4px;
  border: 2px solid ${Colors.GS200};

  &:hover {
    background-color: ${Colors.GS300};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${Colors.B100};
      border: 2px solid ${Colors.B500};

      &:hover {
        background-color: ${Colors.B100};
      }
    `};

  &:hover ${DropdownButton} {
    display: flex;
  }
`

export const LastModified = styled.div`
  color: ${Colors.GS600};
  font-size: 12px;
`

export const ThemeName = styled.div`
  margin-top: 6px;
  font-weight: 600;
  color: ${Colors.GS1000};
`

const smoothOpacity = keyframes`
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.7;
  }
`

export const ImageContainer = styled.button<{
  isTransparent: boolean
}>`
  position: relative;

  ${({ isTransparent }) =>
    isTransparent &&
    css`
      animation: ${smoothOpacity} 3s ease infinite;
    `};

  canvas,
  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 2px;
  }
`

export const TagsContainer = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
`

export const Status = styled.div`
  position: absolute;

  top: 80px;
  right: 50%;
  transform: translateX(50%);
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border-radius: 100px;

  padding: 8px 20px;

  background-color: ${Colors.GS1000};
  font-weight: 600;
  white-space: nowrap;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: ${Colors.GS100};
`

export const DropdownItemLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const BadgesContainer = styled.div`
  display: grid;
  gap: 2px;
`

export const PlaceholderContainer = styled.div`
  width: 288px;
  height: 184px;
`
